<template>
	<div class="header_box" v-show="isShowHead">
		<div class="header">
			<a href="javascript:;" class="head_back" v-if="isShowBack" @click="toBack"></a>
			<span>{{title}}</span>
			<a href="javascript:;" class="head_why" v-if="isShowWhy" @click="toWhy">规则说明</a>
		</div>
	</div>
</template>
<script>
import _ from '@/utils/util'

export default {
	name:'topNav',
	props:{
		title:{
			type:String,
			default:function(){
				return '网易云游戏平台'
			}
		},
		isShowBack:{
			type:Boolean,
			default:function(){
				return true
			}
		},
		isShowWhy:{
			type:Boolean,
			default:function(){
				return true
			}
		}
	},
	data(){
		return {
			isShowHead:true
		}
	},
	mounted(){
		//在微信不显示头部
		// if (_.isWeiXin() || _.isQQ()){
		// 	this.isShowHead = false
		// }
	},
	methods:{
		toBack(){
			console.log(window.history.length)
			if (_.getDetect().os.neteaseCloud){
				window.NCGJsBridge.quit()

			} else if (window.history.length > 1){
				this.$router.go(-1)

			} else {
				window.location.href = process.env.VUE_APP_HOME_URL
			}
		},
		toWhy(){
			this.$emit('rule')
		}
	}
}
</script>